import L, { Control, TileLayer } from 'leaflet';

export class MapUtils {

  public static readonly mapUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY3JlYXRlY3RybHBvbHNrYSIsImEiOiJjbGpkeXk0M3kwM212M2dzNGd3bHkxdmR0In0.YrrJQGidbd4KBLsuZ36MlQ';
  public static readonly mapBoxAttributes = `Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>, Geocoding by <a href="https://nominatim.openstreetmap.org/">Nominatim</a>`;
  public static readonly mapPin = L.icon({
    iconUrl: 'assets/images/map-markers/marker-icon.png',
    iconRetinaUrl: 'assets/images/map-markers/marker-icon-2x.png',
    shadowUrl: 'assets/images/map-markers/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
  });

  public static get kindOfMaps(): Control.LayersObject {
    return {
      'Grayscale': MapUtils.getTitleLayer('mapbox/light-v9'),
      'Streets': MapUtils.getTitleLayer('mapbox/streets-v11'),
    };
  };

  public static getTitleLayer(id: string): TileLayer {
    return L.tileLayer(
      MapUtils.mapUrl,
      {
        id,
        tileSize: 512,
        zoomOffset: -1,
        attribution: MapUtils.mapBoxAttributes
      }
    );
  }
}
